import React, { Component } from 'react';

import { StyleModalNew } from './styleEducation';
import SelectEmployeeDirectory from '../../../containers/SelectEmployeeDirectory';

// eslint-disable-next-line react/prefer-stateless-function
class Supervisor extends Component {
  render() {
    const { onCloseModal, setEmployeeSelected } = this.props;
    return (
      <StyleModalNew title="Titulo" clickCloseIcon={onCloseModal} tabletSize>
        <SelectEmployeeDirectory setEmployeeSelected={setEmployeeSelected} />
      </StyleModalNew>
    );
  }
}
export default Supervisor;
